import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Button, Input } from "reactstrap";
import { toast } from "react-toastify";
import { Formik, Form, ErrorMessage } from "formik";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { resetPassword, accountUpdate } from "../../../context/actions/user";
import { signUpSchema, signUpInit } from "./schema";
import TextInput from "../../common/FormsInput/FormInput";
import Head from "../Head";
import { checkEmailLink } from "../../../context/actions/user";
import "./../SignupModule.scss";
import { useParams, useHistory } from "react-router-dom";
import LoaderUI from "../../common/loader";

toast.configure();

const AccountSetup = () => {
  localStorage.removeItem("_expiredTime");
  const history = useHistory();
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const [confirmpasswordType, setconfirmPasswordType] = useState("password");
  const [disabled, setDisabled] = useState(false);
  let { passwordtoken } = useParams();
  const [showLoader, setShowLoader] = useState(true);

  /**
   * @description method call to submit valid form
   * @param {Object} params form params
   * @param {Instance} status form status
   */
  const submitForm = async (params) => {
    setDisabled(true);
    params.passwordtoken = passwordtoken;
    console.log(params);
    dispatch(
      accountUpdate(params, (result) => {
        setDisabled(false);
        if (result) {
          history.push("/dashboard");
        }
      })
    );
  };

  useEffect(() => {
    setShowLoader(true);
    dispatch(
      checkEmailLink(passwordtoken, (res) => {
        if (!res) {
          history.push("/link-expired");
        } else {
          setShowLoader(false);
        }
      })
    );
  }, []);

  /**
   * @togglePassword method call to submit valid form
   */

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  /**
   * @toggleconfirmPassword method call to submit valid form
   */

  const toggleconfirmPassword = () => {
    if (confirmpasswordType === "password") {
      setconfirmPasswordType("text");
      return;
    }
    setconfirmPasswordType("password");
  };

  return (
    <>
      {showLoader ? (
        <LoaderUI />
      ) : (
        <div className={`login-blc m-auto signup-box`}>
          <Head
            heading="Welcome! Please setup password to continue."
            className="signup-page"
          />{" "}
          <br />
          <Formik
            initialValues={signUpInit}
            enableReinitialize
            validationSchema={signUpSchema}
            onSubmit={submitForm}
          >
            {(formik) => (
              <Form>
                <TextInput
                  name="password"
                  type={passwordType}
                  placeholder="Enter your password"
                  id="newPassword"
                  value={formik?.values?.password}
                  isRequired={true}
                  label="Password"
                  onChange={formik.handleChange}
                  isIcon
                  togglePassword={togglePassword}
                  passwordType={passwordType}
                  passwordHint
                />

                <TextInput
                  type={confirmpasswordType}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  id="confirmPassword"
                  label="Confirm Password"
                  isRequired={true}
                  value={formik?.values?.confirmPassword}
                  onChange={formik.handleChange}
                  isIcon
                  togglePassword={toggleconfirmPassword}
                  passwordType={confirmpasswordType}
                />
                <div className="term-blc">
                  <label
                    className={`d-flex ${
                      formik.errors.acceptTerms && formik.touched.acceptTerms
                        ? "is-invalid"
                        : ""
                    }`}
                  >
                    <span className="checkbox-blc position-relative">
                      <Input
                        type="checkbox"
                        className="position-absolute"
                        name="acceptTerms"
                        checked={formik?.values?.acceptTerms}
                        onChange={(e) => {
                          formik.setFieldValue("acceptTerms", e.target.checked);
                        }}
                      />
                      <span className="icon-box d-inline-flex align-items-center justify-content-center">
                        <span className="icon d-inline-flex">
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                      </span>
                    </span>
                    <span>
                      By clicking <strong>Complete Setup</strong> below, you
                      agree to our terms of service and privacy statement.
                    </span>
                  </label>
                  <ErrorMessage
                    name="acceptTerms"
                    component="div"
                    className="invalid-feedback w-100"
                  />
                </div>
                <div className="btn-cell d-flex">
                  <Button
                    disabled={disabled}
                    className="flex-fill"
                    color="primary"
                  >
                    Complete Setup
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default AccountSetup;
